import React from "react";
import Header from "../components/Header";
import PartnerCarousel from "../components/Ourparnter";
import Footer from "../components/Footer";
import Reveal from "../components/Reveal";
import heroImage from "../assets/composite-webp/main img.webp";
import badgeCbse from "../assets/composite-icons/cbse-nep.svg";
import badgeFuture from "../assets/composite-icons/future-ready.svg";
import badgeMulti from "../assets/composite-icons/multi-skill.svg";
import badgeHands from "../assets/composite-icons/hands-on.svg";
import objectiveIcon1 from "../assets/composite-webp/(1).webp";
import objectiveIcon2 from "../assets/composite-webp/(2).webp";
import objectiveIcon3 from "../assets/composite-webp/(3).webp";
import objectiveIcon4 from "../assets/composite-webp/(4).webp";
import objectiveIcon5 from "../assets/composite-webp/(5).webp";
import objectiveIcon6 from "../assets/composite-webp/(6).webp";
import labImage1 from "../assets/composite-webp/basic infrastructure.webp";
import labImage2 from "../assets/composite-webp/tool and equipment.webp";
import labImage3 from "../assets/composite-webp/smart learning tool.webp";
import labImage4 from "../assets/composite-webp/safety and support equipment.webp";
import skillIconStem from "../assets/composite-webp/stem.webp";
import skillIconCreative from "../assets/composite-webp/create.webp";
import skillIconVocational from "../assets/composite-webp/skill.webp";
import skillIconEntrepreneurial from "../assets/composite-webp/lead.webp";
import makeInIndia from "../assets/composite-webp/made in india.webp";

const keyObjectives = [
  {
    text: "Promote hands-on and experiential learning",
    icon: objectiveIcon1,
  },
  {
    text: "Strengthen skill education and practical application",
    icon: objectiveIcon2,
  },
  {
    text: "Develop 21st-century skills such as creativity, problem-solving, and collaboration",
    icon: objectiveIcon3,
  },
  {
    text: "Integrate technology, innovation, and vocational skills into regular schooling",
    icon: objectiveIcon4,
  },
  {
    text: "Bridge the gap between theoretical knowledge and real-world skills",
    icon: objectiveIcon5,
  },
  {
    text: "Ensure schools are future-ready and compliant with national education reforms",
    icon: objectiveIcon6,
  },
];

const labIncludes = [
  {
    title: "Basic Infrastructure",
    image: labImage1,
    items: [
      "Reliable power supply and proper ventilation",
      "Strong internet connectivity",
      "Comfortable seating and student workspaces",
      "Flexible layout for collaborative group activities",
    ],
  },
  {
    title: "Tools & Equipment",
    image: labImage2,
    items: [
      "Computers or mobile devices with learning software",
      "Robotics kits and electronics components",
      "3D printers and design/prototyping tools",
      "Microscopes or exploratory tools (as per skills offered)",
    ],
  },
  {
    title: "Digital & Smart Learning Tools",
    image: labImage3,
    items: [
      "Coding and simulation software",
      "Digital learning platforms",
      "Interactive displays or smart boards",
      "Projectors and audio-visual systems",
    ],
  },
  {
    title: "Safety & Support Equipment",
    image: labImage4,
    items: [
      "Fire extinguisher",
      "First-aid kit",
      "Protective gear (gloves, goggles, etc.)",
      "Clearly displayed safety instructions",
    ],
  },
];

const skillsDeveloped = [
  {
    title: "STEM Skills",
    text: "Coding, robotics, electronics, 3D printing",
    icon: skillIconStem,
  },
  {
    title: "Creative & Digital Skills",
    text: "Design, media, innovation",
    icon: skillIconCreative,
  },
  {
    title: "Vocational Skills",
    text: "Basic electrical & mechanical work",
    icon: skillIconVocational,
  },
  {
    title: "Entrepreneurial Skills",
    text: "Ideation, prototyping, presentation",
    icon: skillIconEntrepreneurial,
  },
];

const benefitsSchools = [
  "Meets CBSE Composite Skill Lab requirements",
  "Enhances school profile and parent confidence",
  "One lab supports multiple subjects and classes",
  "Ready for inspections and future CBSE updates",
];

const benefitsStudents = [
  "Practical and experiential learning",
  "Improved creativity and confidence",
  "Better real-world understanding",
  "Early exposure to career-oriented skills",
];

const whyPartner = [
  "End-to-end Composite Skill Lab solutions",
  "Customizable as per school size and budget",
  "CBSE & NEP-aligned lab design",
  "Teacher orientation and implementation support",
  "Reliable service and long-term partnership",
];

const highlightBadges = [
  {
    label: "CBSE & NEP 2020 Aligned",
    icon: badgeCbse,
  },
  {
    label: "Future-ready Infrastructure",
    icon: badgeFuture,
  },
  {
    label: "Multi-skill, Multi-grade Usage",
    icon: badgeMulti,
  },
  {
    label: "Hands-on / Experiential Learning",
    icon: badgeHands,
  },
];

export default function CompositeSkills() {
  return (
    <div className="flex flex-col bg-white min-h-screen">
      <Header />

      {/* Hero */}
      <section className="pt-28 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#2e3192] via-[#2a2e9c] to-[#00AEEF] text-white">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <Reveal className="">
            <div>
            <p className="Utility-font-NunitoSans text-sm sm:text-base tracking-wide uppercase opacity-80">
              Experimind Labs
            </p>
            <h1 className="Utility-font-Montserrat text-3xl sm:text-4xl lg:text-6xl font-bold mt-2">
              Composite Skill Lab
            </h1>
            <p className="Utility-font-Buenard text-base sm:text-lg lg:text-xl mt-4 opacity-90">
              A Complete Hands-On Learning Ecosystem for CBSE Schools
            </p>
            <p className="Utility-font-NunitoSans text-sm sm:text-base mt-6 opacity-90 max-w-xl">
              Prepare your school for the future with a modern, multi-purpose
              space for hands-on experiential learning.
            </p>
            </div>
          </Reveal>
          <Reveal from="right">
            <div className="bg-white/10 border border-white/20 rounded-3xl overflow-hidden h-64 sm:h-80 lg:h-96">
              <img
                src={heroImage}
                alt="Composite Skill Lab"
                className="w-full h-full object-cover"
              />
            </div>
          </Reveal>
        </div>
        <div className="max-w-7xl mx-auto mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4">
          {highlightBadges.map((badge, index) => (
            <Reveal key={index} delay={index * 80}>
              <div className="relative bg-white/10 border border-white/30 rounded-2xl px-4 py-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden">
                <div className="mx-auto w-36 h-36 sm:w-40 sm:h-40 rounded-full border-2 border-dashed border-white/70 flex items-center justify-center">
                  <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-full bg-white/95 border-2 border-white/70 shadow-inner flex items-center justify-center px-4">
                    <span className="Utility-font-Montserrat text-[11px] sm:text-xs font-semibold text-[#2e3192] leading-snug text-center">
                      {badge.label}
                    </span>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* What is Composite Skill Lab */}
      <section className="py-14 sm:py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <Reveal>
          <div className="max-w-7xl mx-auto">
          <h2 className="Utility-font-Montserrat Utility-color-Blue text-2xl sm:text-3xl lg:text-5xl font-bold mb-6">
            What is a Composite Skill Lab?
          </h2>
          <p className="Utility-font-NunitoSans text-gray-700 text-base sm:text-lg leading-relaxed mb-6">
            A Composite Skill Lab is a multipurpose, hands-on learning space
            where students gain practical exposure beyond textbooks. It
            integrates technology, innovation, creativity, and vocational skills
            in a single, well-structured lab.
          </p>
          <p className="Utility-font-NunitoSans text-gray-700 text-base sm:text-lg leading-relaxed mb-10">
            The lab supports project-based and activity-based learning, helping
            students apply classroom concepts to real-life situations.
          </p>

          <div className="bg-gray-50 rounded-3xl p-6 sm:p-10 shadow-lg border border-gray-100">
            <h3 className="Utility-font-Montserrat Utility-color-Blue text-xl sm:text-2xl font-bold mb-6">
              Why CBSE Mandates Composite Skill Labs?
            </h3>
            <p className="Utility-font-NunitoSans text-gray-700 mb-8">
              CBSE mandates Composite Skill Labs to shift education from rote
              learning to competency-based and experiential learning, in
              alignment with the National Education Policy (NEP) 2020.
            </p>
            <h4 className="Utility-font-Montserrat Utility-color-Blue text-lg sm:text-xl font-bold mb-4">
              CBSE&apos;s Key Objectives
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {keyObjectives.map((item, index) => (
                <Reveal key={index} delay={index * 80} from="left">
                  <div className="flex items-start gap-3 bg-white rounded-2xl p-4 shadow-sm hover:shadow-md transition-all duration-300">
                    <div className="w-10 h-10 rounded-full bg-white border-2 border-[#2e3192] flex-shrink-0 flex items-center justify-center">
                      <img
                        src={item.icon}
                        alt=""
                        className="w-6 h-6 object-contain"
                      />
                    </div>
                    <p className="Utility-font-NunitoSans text-gray-700 text-sm sm:text-base">
                      {item.text}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
            <p className="Utility-font-NunitoSans text-gray-600 mt-6 text-sm sm:text-base">
              The Composite Skill Lab acts as a common platform to support
              multiple CBSE skill subjects efficiently under one roof.
            </p>
          </div>
          </div>
        </Reveal>
      </section>

      {/* What you will find */}
      <section className="py-14 sm:py-20 px-4 sm:px-6 lg:px-8 bg-[#2e31923b]">
        <div className="max-w-7xl mx-auto">
          <h2 className="Utility-font-Montserrat Utility-color-Blue text-2xl sm:text-3xl lg:text-5xl font-bold mb-10">
            What You Will Find Inside the Composite Skill Lab
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {labIncludes.map((block, index) => (
              <Reveal key={index} delay={index * 80}>
                <div className="bg-white rounded-3xl shadow-lg border border-gray-100 p-6 sm:p-8 hover:shadow-xl transition-all duration-300">
                  <div className="flex items-center justify-between gap-4 mb-4">
                    <h3 className="Utility-font-Montserrat Utility-color-Blue text-lg sm:text-xl font-bold">
                      {block.title}
                    </h3>
                    <div className="w-24 h-16 rounded-lg bg-gray-100 border border-gray-200 overflow-hidden">
                      <img
                        src={block.image}
                        alt={block.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                  <div className="space-y-2">
                    {block.items.map((item, i) => (
                      <p
                        key={i}
                        className="Utility-font-NunitoSans text-gray-700 text-sm sm:text-base"
                      >
                        {item}
                      </p>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-12">
            <h3 className="Utility-font-Montserrat Utility-color-Blue text-xl sm:text-2xl font-bold mb-6">
              Skills Developed in the Composite Skill Lab
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {skillsDeveloped.map((skill, index) => (
                <Reveal key={index} delay={index * 80}>
                  <div className="bg-white rounded-2xl shadow-lg p-6 text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                    <div className="w-16 h-16 rounded-full border-2 border-[#2e3192] mx-auto mb-4 flex items-center justify-center">
                      <img
                        src={skill.icon}
                        alt=""
                        className="w-10 h-10 object-contain"
                      />
                    </div>
                    <h4 className="Utility-font-Montserrat Utility-color-Blue text-lg font-bold mb-2">
                      {skill.title}
                    </h4>
                    <p className="Utility-font-NunitoSans text-gray-600 text-sm">
                      {skill.text}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-14 sm:py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <Reveal>
              <div className="bg-[#2e3192] text-white rounded-3xl p-6 sm:p-8 shadow-lg">
              <h3 className="Utility-font-Montserrat text-xl sm:text-2xl font-bold mb-6">
                Benefits for Schools
              </h3>
              <div className="space-y-3">
                {benefitsSchools.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-3 bg-white/10 rounded-xl p-3"
                  >
                    <div className="w-5 h-5 rounded-full bg-green-400 mt-1"></div>
                    <p className="Utility-font-NunitoSans text-sm sm:text-base">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
              </div>
            </Reveal>

            <Reveal delay={120}>
              <div className="bg-[#2a2e9c] text-white rounded-3xl p-6 sm:p-8 shadow-lg">
              <h3 className="Utility-font-Montserrat text-xl sm:text-2xl font-bold mb-6">
                Benefits for Students
              </h3>
              <div className="space-y-3">
                {benefitsStudents.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-3 bg-white/10 rounded-xl p-3"
                  >
                    <div className="w-5 h-5 rounded-full bg-green-400 mt-1"></div>
                    <p className="Utility-font-NunitoSans text-sm sm:text-base">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Why Partner */}
      <section className="py-14 sm:py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <Reveal>
            <div>
            <h3 className="Utility-font-Montserrat Utility-color-Blue text-2xl sm:text-3xl font-bold mb-6">
              Why Partner With Us?
            </h3>
            <div className="space-y-3">
              {whyPartner.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-4 shadow-md hover:shadow-lg transition-all duration-300"
                >
                  <p className="Utility-font-NunitoSans text-gray-700 text-sm sm:text-base">
                    {item}
                  </p>
                </div>
              ))}
            </div>
            <p className="Utility-font-Buenard text-gray-700 text-base sm:text-lg mt-6 font-bold">
              Build Skills. Inspire Innovation. Shape the Future.
            </p>
            </div>
          </Reveal>
          <Reveal from="right">
            <div className="bg-white rounded-3xl border border-gray-200 h-64 sm:h-80 flex items-center justify-center overflow-hidden">
              <img
                src={makeInIndia}
                alt="Make in India"
                className="w-full h-full object-contain p-6"
              />
            </div>
          </Reveal>
        </div>
      </section>

      <PartnerCarousel />
      <Footer />
    </div>
  );
}


